import NoFunds from './noFunds'
import { SectionError } from 'components/states'
import AccessPay from './accessPay'
import useGetFunds from './hooks/useGetFunds'
import DotsLoading from 'components/loadings/dotsLoading'
import MoneyPools from './moneyPools'
import CashBoxes from './cashBoxes'

export default function Funds() {
    const { moneyPools, cashBoxes, isLoading, isError, refetch } =
        useGetFunds()
    return (
        <div className="bg-[#FAFAFA] min-h-screen">
            {isLoading ? (
                <DotsLoading />
            ) : isError || !moneyPools ? (
                // Used to fall through to <DotsLoading/> and spin forever: the
                // branch tested `!moneyPools`, which stays undefined on error.
                <div className="p-4">
                    <SectionError onRetry={() => refetch()} />
                </div>
            ) : moneyPools.length > 0 ? (
                <>
                    <AccessPay />
                    <div className="px-4 pt-4 pb-[60px]">
                        {cashBoxes && <CashBoxes cashBoxes={cashBoxes} />}
                        <MoneyPools moneyPools={moneyPools} />
                    </div>
                </>
            ) : (
                <NoFunds />
            )}
        </div>
    )
}
